module.exports = __webpack_public_path__ + "media/dingup.db9c49a1.mp3";